var global = require('../internals/global');
var isObject = require('../internals/is-object');

var String = global.String;
var TypeError = global.TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/an-object.js
// module id = 12
// module chunks = 49